import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  font-size: 0;
  line-height: 0;
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Auth/StyledComponents/Container.js